import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import Immutable from 'immutable';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import WarningIcon from '@material-ui/icons/Warning';
import EventSelector from 'components/Event/EventSelector';
import EventSubscription from 'components/EventSubscription/EventSubscription';
import RemainingTime from 'components/UI/RemainingTime';
import EventSubscriptionVisitor from 'components/EventSubscription/EventSubscriptionVisitor';
import EventSubscriptionFor from 'components/EventSubscription/EventSubscriptionFor';
import i18n from 'helpers/i18n';
import { formatDate } from 'helpers/stringUtils';
import getCardImage from 'helpers/getCardImage';
import getRemainingTime from 'helpers/getRemainingTime';
// import _compact from "lodash/compact";
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';

const styles = (theme) => {
  return {
    root: {
      marginBottom: '30px',
    },
    eventTitle: {
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        order: 2,
      },
    },
    eventSpeaker: {
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
        order: 1,
      },
    },
    title: {
      borderBottom: 'none',
      margin: 0,
      padding: 0,
    },
    avatar: { width: '100%', height: '100%', maxWidth: 150, maxHeight: 150 },
    inline: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    inlineIcon: {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginTop: '-3px',
      marginRight: theme.spacing(1),
    },
    h6extends: {
      color: theme.palette.secondary.main,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    },
    underline: {
      position: 'relative',
      paddingBottom: 30,
      '&:after': {
        content: '" "',
        position: 'absolute',
        bottom: 0,
        width: 100,
        left: 'calc(50% - (100px/2))',
        height: 2,
        borderBottom: '2px ' + theme.palette.secondary.main + ' solid',
      },
    },
    boxWrapper: {
      width: '100%',
      backgroundColor: theme.palette.primary.light,
      padding: 40,
      marginBottom: 20,
      [theme.breakpoints.down('sm')]: {
        padding: 20,
      },
    },
    eventSubscriptionWrapper: {
      textAlign: 'right',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    fullWidth: {
      width: '100%',
    },
  };
};

class EventCardEmbed extends Component {
  constructor(props) {
    super(props);

    // const $$selectedEvents = this._getSelectedEvents(props);

    this.state = {
      remainingTime: 0,
      remainingTimeDays: 0,
      remainingTimeHours: 0,
      remainingTimeMinutes: 0,
      // step: $$selectedEvents.size > 0 ? "summary" : "register",
      showLiveButton: false,
      // $$selectedEvents,
    };
    this._runRemainingTimer = this._runRemainingTimer.bind(this);
    // this._handleStepChange = this._handleStepChange.bind(this);
    // this._onSelectionComplete = this._onSelectionComplete.bind(this);
    // this._onSubscriptionRequest = this._onSubscriptionRequest.bind(this);
    // this._goBack = this._goBack.bind(this);
  }

  componentDidMount() {
    // if (this.props.showRemainingTime === true) this._startTimer();
  }

  componentDidUpdate(oldProps) {
    const { showRemainingTime, $$subscriptions } = this.props;
    // if (
    //   showRemainingTime === true &&
    //   oldProps.$$subscriptions.size !== $$subscriptions.size
    // ) {
    //   this.setState(
    //     {
    //       $$selectedEvents: this._getSelectedEvents(),
    //     },
    //     () => {
    //       this._startTimer();
    //     }
    //   );
    // }

    if (oldProps.$$subscriptions !== this.props.$$subscriptions) {
      // if (this._getHasSubscribed()) {
      // this._handleStepChange("summary");
      // this._stopTimer();
      // this.setState(
      //   {
      //     $$selectedEvents: this._getSelectedEvents(),
      //   },
      //   () => {
      //     this._startTimer();
      //   }
      // );
      // } else {
      //   this._handleStepChange("register");
      // }
    }
  }

  componentWillUnmount() {
    this._stopTimer();
  }

  // _getSelectedEvents(thatProps) {
  //   const props = thatProps || this.props;
  //   const { $$subscriptions, $$themeData } = props;
  //
  //   let $$selectedEvents = [];
  //   $$themeData.forEach((event) => {
  //     if ($$subscriptions.contains(event.get("id"))) {
  //       $$selectedEvents.push(event);
  //     }
  //   });
  //
  //   return Immutable.fromJS($$selectedEvents);
  // }

  // _handleStepChange(step) {
  //   if (step !== this.state.step) {
  //     this.setState({ step });
  //   }
  // }

  _stopTimer() {
    if (this._remainingTimer) {
      clearInterval(this._remainingTimer);
    }
  }

  _startTimer() {
    // const { $$selectedEvents } = this.state;
    // if ($$selectedEvents.size < 1) return;
    // this._cardTimer = $$selectedEvents.get(0).get("eventDate");
    this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
    this._runRemainingTimer();
  }

  // _runRemainingTimer() {
  //   const countDownDate = this._cardTimer;
  //   if (!countDownDate) return;
  //   const now = new Date().getTime();
  //   const distance = countDownDate * 1000 - now;
  //
  //   const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //   const hours = Math.floor(
  //     (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  //   );
  //   const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //
  //   const tStr =
  //     days +
  //     " Jour" +
  //     (days > 1 ? "s" : "") +
  //     " " +
  //     hours +
  //     " Heure" +
  //     (hours > 1 ? "s" : "") +
  //     " " +
  //     minutes +
  //     " Minute" +
  //     (minutes > 1 ? "s" : "") +
  //     "";
  //   this.setState({
  //     remainingTime: tStr,
  //     remainingTimeDays: days,
  //     remainingTimeHours: hours,
  //     remainingTimeMinutes: minutes,
  //   });
  //   if (distance < 0) {
  //     clearInterval(this._remainingTimer);
  //     this.setState({ showLiveButton: true });
  //   }
  // }

  _runRemainingTimer() {
    // console.log('run1')
    const { $$card } = this.state;

    const $$liveEvent = $$card;
    // console.log('tt', $$liveEvent.toJS())

    // console.log('run2', $e)
    if ($$liveEvent === undefined) {
      return this._stopTimer();
    }
    // console.log('run3')
    // console.log($e)
    // console.log($e.get('eventState'))
    const timeRemaining =
      $$liveEvent !== undefined && $$liveEvent.get('eventState') != 'live'
        ? getRemainingTime($$liveEvent.get('eventDate'))
        : { days: 0, hours: 0, minutes: 0 };
    // console.log(timeRemaining)
    if (timeRemaining.days <= 0 && timeRemaining.hours <= 0 && timeRemaining.minutes <= 15) {
      this.setState({ showLiveButton: true }, () => {
        // console.log('STOPPPING')
        this._stopTimer();
      });
    } else {
      // console.log('RUN')
      this.setState({ timeRemaining });
    }
  }

  _generateCardDescription() {
    const { classes, $$card } = this.props;
    const $$data = $$card;
    const cardImage = getCardImage($$data) || '';

    return (
      <React.Fragment>
        <Grid
          container
          item
          xs={12}
          style={{ borderBottom: '#083845 1px solid' }}
          alignItems="flex-end"
          justify="space-between"
        >
          <Grid item xs={12} md={6} className={classes.eventTitle}>
            <Typography variant="h3" className={classes.title} component="div">
              <Paragrapher prettyfy={true} text={$$data.get('eventTitle')} element="div"/>
            </Typography>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={6}
            alignItems="flex-end"
            justify="space-between"
            className={classes.eventSpeaker}
          >
            <Grid item xs={8}>
              <Box mr={2}>
                <Typography variant="body2" align="right">
                  {i18n.get('cardPresentedBy')} <strong>{$$data.get('eventGuests')}</strong>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Avatar src={cardImage} className={classes.avatar} variant="square"></Avatar>
            </Grid>
          </Grid>
        </Grid>
        <Box mt={4} mb={4}>
          <Typography variant="body1" component="div" align="left">
            <Paragrapher prettyfy={true} text={$$data.get('eventDescription')} element="div"/></Typography>
        </Box>
      </React.Fragment>
    );
  }

  _onSubscriptionRequest = () => {
    const { $$subscriptions, $$themeData } = this.props;
    const { $$selectedEvents } = this.state;

    if (!$$selectedEvents || $$selectedEvents.size < 1) {
      return Immutable.fromJS([]);
    }

    const allThemeDataIds = $$themeData.map((e) => e.get('id'));
    // const allSubscriptionsWithoutThisTheme = _compact(
    //   $$subscriptions.map((id) => {
    //     if (!allThemeDataIds.contains(id)) {
    //       return id;
    //     }
    //   })
    // );
    const allSubscriptionsWithoutThisTheme = $$subscriptions
      .filter((id) => !allThemeDataIds.contains(id))
      .toArray();

    const selectedThemeEvents = $$selectedEvents.map((e) => e.get('id')).toArray();

    return Immutable.fromJS([...allSubscriptionsWithoutThisTheme, ...selectedThemeEvents]);
  };

  _onSelectionComplete = ($$selectedEvents) => {
    this.setState({ $$selectedEvents });
  };

  _onSelectionReset = () => {
    this.setState({ $$selectedEvents: Immutable.fromJS([]) });
  };

  _onComplete = () => {
    const { onSubscriptionComplete } = this.props;
    onSubscriptionComplete();
    this._handleStepChange('summary');
  };

  _onCompleteWithError = () => {
    const { onSubscriptionComplete } = this.props;
    onSubscriptionComplete();
    this._handleStepChange('register');
  };

  _getHasSubscribed = () => {
    const { $$subscriptions, $$themeData } = this.props;

    let hasSubscribed = false;

    $$subscriptions.forEach((id) => {
      if ($$themeData.find((e) => e.get('id') === id)) {
        hasSubscribed = true;
      }
    });
    return hasSubscribed;
  };

  _goBack() {
    let $$selectedEvents = [];

    this.props.$$themeData.forEach((event) => {
      if (this.props.$$subscriptions.contains(event.get('id'))) {
        $$selectedEvents.push(event);
      }
    });
    this.setState({
      $$selectedEvents: Immutable.fromJS($$selectedEvents),
    });
    this._handleStepChange('summary');
  }

  // _generateSummaryContent() {
  //   const { classes } = this.props;
  //
  //   const {
  //     // remainingTimeDays,
  //     // remainingTimeHours,
  //     // remainingTimeMinutes,
  //     showLiveButton,
  //     $$selectedEvents,
  //   } = this.state;
  //
  //   if ($$selectedEvents.size < 1) return;
  //
  //   const timeRemaining =
  //     $$selectedEvents !== undefined && $$selectedEvents.size >= 0
  //       ? getRemainingTime($$selectedEvents.get(0).get("eventDate"))
  //       : {};
  //   // console.log('FOO', timeRemaining)
  //   const wording =
  //     $$selectedEvents.size > 1
  //       ? {
  //           session: "aux sessions suivantes",
  //           nextConf: "Votre prochaine conférence débute dans:",
  //         }
  //       : {
  //           session: "à la session suivante",
  //           nextConf: "La conférence débute dans:",
  //         };
  //   // console.log({      remainingTimeDays,
  //   //       remainingTimeHours,
  //   //       remainingTimeMinutes,
  //   // })
  //   return (
  //     <Grid container alignItems="center" justify="space-around">
  //       <Grid item xs={12} md={2}></Grid>
  //       <Grid item xs={12} md={8}>
  //         <Box align="center" className={classes.fullWidth}>
  //           <Typography
  //             variant="h4"
  //             style={{ textTransform: "uppercase" }}
  //             gutterBottom={true}
  //           >
  //             {`Vous êtes inscrit(e) ${wording.session}:`}
  //           </Typography>
  //
  //           {$$selectedEvents.map(($$event) => {
  //             return (
  //               <Typography
  //                 key={"evt_" + $$event.get("id")}
  //                 variant="h6"
  //                 className={clsx(classes.legend, classes.h6extends)}
  //                 gutterBottom={true}
  //               >
  //                 {formatDate($$event.get("eventDate"), "dddd dd mmmm yyyy") +
  //                   " - " +
  //                   formatDate($$event.get("eventDate"), "HH'h'MM")}
  //               </Typography>
  //             );
  //           })}
  //         </Box>
  //
  //         <Box mt={4} className={classes.fullWidth} align="center">
  //           <If condition={showLiveButton !== true}>
  //             <Typography
  //               variant="h6"
  //               gutterBottom={true}
  //               className={clsx(classes.legend, classes.h6extends)}
  //             >
  //               {`${wording.nextConf}`}
  //             </Typography>
  //
  //             <RemainingTime
  //               days={timeRemaining.days}
  //               hours={timeRemaining.hours}
  //               minutes={timeRemaining.minutes}
  //             />
  //           </If>
  //         </Box>
  //       </Grid>
  //       <Grid item xs={12} md={2}>
  //         <If condition={showLiveButton !== true}>
  //           <Box mt={2} align="center" className={classes.alignCenter}>
  //             <Button
  //               variant="outlined"
  //               color="secondary"
  //               onClick={(e) => {
  //                 e.preventDefault();
  //                 this._handleStepChange("register");
  //               }}
  //             >
  //               {i18n.get("cardUpdateBtn")}
  //             </Button>
  //           </Box>
  //         </If>
  //         <If condition={showLiveButton === true}>
  //           <Typography variant="body1" align="center" gutterBottom={true}>
  //             {i18n.get("cardSubtitle1")}
  //           </Typography>
  //           <Box mt={2} align="center" className={classes.fullWidth}>
  //             <Button
  //               variant="outlined"
  //               color="secondary"
  //               onClick={this.props._gotoLiveRoom}
  //               className={classes.buttonLarge}
  //             >
  //               {i18n.get("cardLiveBtn")}
  //             </Button>
  //           </Box>
  //         </If>
  //       </Grid>
  //     </Grid>
  //   );
  // }

  // _generateCardContent = () => {
  //   const {
  //     $$themeData,
  //     classes,
  //     userRole,
  //     $$user,
  //     $$subscriptions,
  //   } = this.props;
  //
  //   const { step } = this.state;
  //   const hasSubscribed = this._getHasSubscribed();
  //
  //   return (
  //     <Choose>
  //       <When condition={step === "summary"}>
  //         <Box align="middle" className={classes.boxWrapper}>
  //           {this._generateSummaryContent()}
  //         </Box>
  //
  //         <Box align="center" className={classes.fullWidth} mt={6} mb={6} px={6}>
  //           <Grid
  //             container={true}
  //             spacing={2}
  //             alignItems="center"
  //             justify="space-around"
  //           >
  //             <Grid item={true} xs={12} sm={1}>
  //               <WarningIcon className={classes.inlineIcon} />
  //             </Grid>
  //             <Grid item={true} xs={12} sm={11}>
  //               <Typography variant={"body2"}>
  //                 {i18n.get("cardWarning")}
  //               </Typography>
  //             </Grid>
  //           </Grid>
  //         </Box>
  //       </When>
  //
  //       {/* <When condition={$pastEvent !== undefined}>
  //         <Box mt={4}></Box>
  //
  //         <Box
  //           align="middle"
  //           mt={-3}
  //           mb={4}
  //           bgcolor="common.white"
  //           maxWidth={"80%"}
  //           ml={"10%"}
  //           py={3}
  //           px={3}
  //         >
  //           <Typography variant="subtitle2" gutterBottom={true}>
  //             Vous etiez inscrit(e) à la session suivante:
  //           </Typography>
  //           <Typography
  //             variant="h6"
  //             className={clsx(classes.legend, classes.h6extends)}
  //             gutterBottom={true}
  //           >
  //             {formatDate($pastEvent.get("eventDate"), "dddd dd mmmm yyyy")} -{" "}
  //           </Typography>
  //           <Typography
  //             variant="h6"
  //             className={classes.legend}
  //             gutterBottom={true}
  //           >
  //             {formatDate($pastEvent.get("eventDate"), "HH'h'MM")}
  //           </Typography>
  //
  //           <Choose>
  //             <When
  //               condition={
  //                 $pastEvent.get("hasAttended") === undefined &&
  //                 $pastEvent.get("hasAttended") === "" &&
  //                 $pastEvent.get("hasAttended") === null
  //               }
  //             >
  //               <Typography variant="h6" gutterBottom={true}>
  //                 <span className={classes.inline}>
  //                   La conférence est terminée, mais vous n'y avez pas assisté.
  //                 </span>
  //                 <span className={classes.inline}>
  //                   Vous pouvez donc vous inscrire à une nouvelle
  //                   conférence&nbsp;!
  //                 </span>
  //               </Typography>
  //               <Button
  //                 size={"large"}
  //                 onClick={(e) => {
  //                   e.preventDefault();
  //                   this.props.handleStepChange("register");
  //                 }}
  //                 className={classes.buttonLarge}
  //               >
  //                 Modifier ma session
  //               </Button>
  //             </When>
  //             <Otherwise>
  //               <Typography variant="h6" gutterBottom={true}>
  //                 La conférence est terminée !
  //               </Typography>
  //             </Otherwise>
  //           </Choose>
  //         </Box>
  //       </When> */}
  //
  //       <When condition={step === "error"}>
  //         <Box pb={10}>
  //           <Box align="center" mb={4} px={2}>
  //             <Typography
  //               variant={"h2"}
  //               classes={{ root: classes.h2 }}
  //               gutterBottom
  //             >
  //               {i18n.get("subscriptionSelfErrorTitle", {
  //                 prettyfy: true,
  //               })}
  //             </Typography>
  //           </Box>
  //
  //           <Box align="center" mb={4} px={2}>
  //             <If condition={i18n.has("subscriptionSelfErrorText")}>
  //               <Typography
  //                 variant={"h5"}
  //                 classes={{ root: classes.h5 }}
  //                 gutterBottom
  //               >
  //                 {i18n.get("subscriptionSelfErrorText")}
  //               </Typography>
  //             </If>
  //           </Box>
  //           <Box align="middle">
  //             <Button size="large" onClick={this._onCompleteWithError}>
  //               {i18n.get("cardErrorBtn")}
  //             </Button>
  //           </Box>
  //         </Box>
  //       </When>
  //       <Otherwise>
  //         <Grid container item xs={12} justify="center" alignItems="center">
  //           <Grid
  //             item
  //             xs={12}
  //             md={userRole === "admin" ? 12 : 9}
  //           >
  //             <EventSelector
  //               $$data={$$themeData.sort((a, b) => {
  //                 if (a.get("eventDate") > b.get("eventDate")) return 1;
  //                 if (a.get("eventDate") < b.get("eventDate")) return -1;
  //                 return 0;
  //               })}
  //               $$subscriptions={$$subscriptions}
  //               userRole={userRole}
  //               onSelectionComplete={this._onSelectionComplete}
  //               $$user={$$user}
  //             />
  //           </Grid>
  //
  //           <If condition={userRole !== "admin"}>
  //             <Grid
  //               item
  //               xs={12}
  //               md={3}
  //               className={classes.eventSubscriptionWrapper}
  //             >
  //               <If
  //                 condition={userRole === undefined || userRole === "visitor"}
  //               >
  //                 <EventSubscriptionVisitor
  //                   userRole={userRole}
  //                   showRecap={false}
  //                   $$user={$$user}
  //                   onSubscriptionComplete={this._onComplete}
  //                   onSubscriptionError={this._onSubscriptionError}
  //                   onSubscriptionRequest={this._onSubscriptionRequest}
  //                   hasSubscribed={hasSubscribed}
  //                   onCancel={() => {
  //                     this._handleStepChange("summary");
  //                   }}
  //                 />
  //               </If>
  //               <If condition={userRole === "member" || userRole === "staff"}>
  //                 <EventSubscription
  //                   userRole={userRole}
  //                   showRecap={false}
  //                   $$user={$$user}
  //                   onSubscriptionComplete={this._onComplete}
  //                   onSubscriptionError={this._onSubscriptionError}
  //                   onSubscriptionRequest={this._onSubscriptionRequest}
  //                   hasSubscribed={hasSubscribed}
  //                   onCancel={() => {
  //                     this._handleStepChange("summary");
  //                   }}
  //                 />
  //               </If>
  //             </Grid>
  //           </If>
  //
  //           <If condition={userRole === "admin"}>
  //             <Grid item xs={12}>
  //               <Box align="center" mt={2}>
  //                 <EventSubscriptionFor
  //                   userRole={userRole}
  //                   showRecap={false}
  //                   $$user={$$user}
  //                   onSubscriptionComplete={this._onComplete}
  //                   onSubscriptionError={this._onSubscriptionError}
  //                   onSubscriptionRequest={this._onSubscriptionRequest}
  //                   hasSubscribed={hasSubscribed}
  //                   onCancel={() => {
  //                     this._handleStepChange("summary");
  //                   }}
  //                 />
  //               </Box>
  //             </Grid>
  //           </If>
  //         </Grid>
  //         <If condition={hasSubscribed === true}>
  //           <Box mt={6} align="right">
  //             <Button
  //               variant="outlined"
  //               color="secondary"
  //               onClick={this._goBack}
  //             >
  //               {i18n.get("cardGoBackBtn")}
  //             </Button>
  //           </Box>
  //         </If>
  //       </Otherwise>
  //     </Choose>
  //   );
  // };

  render() {
    const { tIdx, $$card, classes } = this.props;
    return (
      <Box maxWidth={1280} mx={'auto'}>
        <Grid
          key={'evt_' + tIdx}
          item
          xs={12}
          container
          id={'event-card-' + $$card.get('themeName')}
          className={classes.root}
        >
          {this._generateCardDescription()}
          <Box mt={4} mb={4}>
            <Divider light />
          </Box>
        </Grid>
      </Box>
    );
  }
}

export default withRouter(withStyles(styles)(EventCardEmbed));



// WEBPACK FOOTER //
// ./src/components/Event/EventCardEmbed.jsx